import React from "react";
import fetch from "isomorphic-fetch";
import "dotenv/config";
import configData from "../config.json";

const AffiliateLink = (props) => {
  const { product, className } = props;
  const productId = product.id || product.strapiId;

  let affiLink;
  if (product.isAffiLinkDead) {
    affiLink = product.isAmazonProduct
      ? `https://www.amazon.com/s?k=${product.name}&tag=${configData.AMAZON_TRACKING_ID}`
      : null;
  } else {
    affiLink = product.isAmazonProduct
      ? `https://www.amazon.com/dp/${product.affiLink}?tag=${configData.AMAZON_TRACKING_ID}`
      : product.affiLink;
  }

  const handleAffiliateCheck = () => {
    const apiHost = process.env.GATSBY_API_URL || "http://localhost:1337";
    if (!product.isAffiLinkDead) {
      fetch(`${apiHost}/products/${productId}/check-affiliate-link`);
    }
  };

  return (
    <a
      href={affiLink}
      className={className}
      target="_blank"
      rel="noreferrer"
      onClick={handleAffiliateCheck}
    >
      {props.children}
    </a>
  );
};

export default AffiliateLink;
